import React, { useContext, useState } from "react";
import { Icon } from "@iconify/react";
import { useTheme, Avatar } from "@/design-system";
import AuthContext from "../../contexts/AuthContext";
import { usePWAInstallPrompt } from "../../common/usePWAInstallPrompt";
import InstallPrompt from "../InstallPrompt";
import "./AppLayout.css";

const AppHeader = ({ onProfileClick }) => {
  const { theme, toggleTheme } = useTheme();
  const Context = useContext(AuthContext);
  const { showInstallPrompt, isIOSDevice, isAppInstalled } = usePWAInstallPrompt();
  const [installPromptOpen, setInstallPromptOpen] = useState(false);

  const user = Context?.state?.user?.attributes || {};
  const userName = user.name || user.email?.split("@")[0] || "User";
  const userPicture = user.picture;

  const handleAddToHomeScreen = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    console.log("Install App button clicked", { isAppInstalled, isIOSDevice, showInstallPrompt: !!showInstallPrompt });
    // Always show the InstallPrompt modal when button is clicked
    // The modal will handle showing iOS instructions or triggering native prompt
    setInstallPromptOpen(true);
  };

  const handleInstallPromptClose = () => {
    setInstallPromptOpen(false);
  };

  return (
    <>
      <header className="app-header">
        <div className="app-header__logo">Sponsor App</div>
        <div className="app-header__actions">
          {!isAppInstalled && (
            <button
              type="button"
              className="app-header__install-btn"
              onClick={handleAddToHomeScreen}
              aria-label="Install App"
            >
              <Icon icon="material-symbols:add-to-home-screen-outline" width="18" height="18" />
              <span>Install App</span>
            </button>
          )}
          <button
            className="app-header__theme-btn"
            onClick={toggleTheme}
            aria-label="Toggle theme"
          >
            <Icon
              icon={theme === "dark" ? "flowbite:sun-outline" : "flowbite:moon-outline"}
              width="24"
              height="24"
            />
          </button>
          <Avatar
            src={userPicture}
            name={userName}
            size={36}
            onClick={onProfileClick}
            className="app-header__avatar"
          />
        </div>
      </header>

      {/* Install Prompt for iOS instructions */}
      {installPromptOpen && (
        <InstallPrompt
          onInstall={showInstallPrompt}
          isIOSDevice={isIOSDevice}
          isVisible={true}
          showIOSInstructionsDirectly={isIOSDevice}
          onClose={handleInstallPromptClose}
        />
      )}
    </>
  );
};

export default AppHeader;
